var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHplogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216,432c-2.15,0-4.29,0-6.42-.1l44.14-121.32h60.75c10.67,0,22.37-8.2,26-18.21l47.89-131.55c7.83-21.53-4.5-39.15-27.42-39.15H276.68L206,316h0L165.85,426.14C70.74,403.52,0,318,0,216,0,116.92,66.72,33.42,157.68,8l-41.36,113.7h0L47.54,310.58H93.32L151.8,150.06h34.4L127.72,310.59h45.76L228,160.82c7.84-21.53-4.5-39.15-27.39-39.15H162.11L206.29.23Q211.12,0,216,0C335.29,0,432,96.71,432,216S335.29,432,216,432ZM346.69,149.94H312.3L264.13,282.1h34.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHplogo);
export default __webpack_public_path__ + "static/media/hplogo.6763ecf9d323a5e19ee9aecdbf36ef6c.svg";
export { ForwardRef as ReactComponent };